import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-role",
  "use": "icon-role-usage",
  "viewBox": "0 0 1170 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1170 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-role\"><path d=\"M146.286 0H1024a146.286 146.286 0 0 1 146.286 146.286v731.428A146.286 146.286 0 0 1 1024 1024H146.286A146.286 146.286 0 0 1 0 877.714V146.286A146.286 146.286 0 0 1 146.286 0zm219.428 585.143a146.286 146.286 0 1 0 0-292.572 146.286 146.286 0 0 0 0 292.572zM158.72 731.429h413.989a219.502 219.502 0 0 0-413.989 0zm572.709-365.715v73.143H1024v-73.143H731.429zm0 219.429v73.143H1024v-73.143H731.429z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol